import { render } from "./PageKeywordsReviewStatus.vue?vue&type=template&id=9593113c"
import script from "./PageKeywordsReviewStatus.vue?vue&type=script&lang=js"
export * from "./PageKeywordsReviewStatus.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__